import { PhoneIcon } from "lucide-react";
import { buttonVariants } from "../Diwalipage/Button";
import { site } from "../../config/site";
import { trackEvent } from "../../lib/tracking";
import { cn } from "../../lib/utils";

export function SiteHeader({
  ctaLabel,
  ctaHref,
  showPhone = true,
  hideCtaOnMobile = false,
  banner,
}) {
  return (
    <header className="fixed inset-x-0 top-0 z-40">
      {banner}

      <div className="px-3 pt-3 sm:px-4">
        <div className="mx-auto flex h-16 max-w-[1140px] items-center justify-between gap-3 rounded-lg bg-[#e7f7ed] px-4 shadow-header backdrop-blur sm:px-[22px] md:h-[74px]">
          <a
            href={site.links.home}
            aria-label="Onbbits home"
            className="shrink-0"
          >
            <img
              src="/logo.svg"
              alt="Onbbits Logo"
              style={{
                display: "block",
                width: "130px",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </a>

          <div className="flex items-center gap-3 md:gap-5 max-[575px]:hidden">
            {showPhone && (
              <a
                href={site.phoneHref}
                onClick={() =>
                  trackEvent("call_click", { location: "header" })
                }
                className="flex items-center gap-2 text-xs font-medium hover:text-brand-text sm:text-sm"
              >
                <PhoneIcon
                  className="size-4 text-brand-text"
                  aria-hidden="true"
                />
                {site.phoneDisplay}
              </a>
            )}

            {ctaLabel && ctaHref && (
              <a
                href={ctaHref}
                className={buttonVariants({
                  className: cn(
                    "h-10 px-4 md:h-11",
                    hideCtaOnMobile && "max-md:hidden"
                  ),
                })}
              >
                {ctaLabel}
              </a>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}